import { useEffect, useState } from "react";
import axios from "axios";
import { Bookmark, BookmarkCheck } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WatchButton = ({ type, refId, label = "", light = false, className = "" }) => {
  const { featureMode } = useAuth();
  const mode = featureMode("watchlists");
  const [item, setItem] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (mode !== "full" || !refId) return undefined;
    let alive = true;
    axios
      .get(`${API}/watchlist/check`, { params: { type, ref_id: refId } })
      .then((r) => alive && setItem(r.data.item))
      .catch(() => {});
    return () => { alive = false; };
  }, [type, refId, mode]);

  if (mode !== "full" || !refId) return null;

  const saved = !!item;
  const toggle = async () => {
    if (busy) return;
    setBusy(true);
    try {
      if (saved) {
        await axios.delete(`${API}/watchlist/${item.item_id}`);
        setItem(null);
        toast.success("Removed from watchlist");
      } else {
        const r = await axios.post(`${API}/watchlist`, { type, ref_id: refId, label });
        setItem(r.data);
        toast.success("Added to watchlist");
      }
    } catch {
      toast.error("Watchlist update failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={toggle}
      disabled={busy}
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors ${
        saved
          ? light
            ? "border-orange-300 bg-orange-50 text-orange-700"
            : "border-orange-500/50 bg-orange-500/15 text-orange-300"
          : light
          ? "border-gray-300 bg-white text-gray-600 hover:border-orange-300 hover:text-orange-600"
          : "border-white/20 bg-white/5 text-white/60 hover:border-orange-500/50 hover:text-orange-300"
      } ${className}`}
      title={saved ? "Remove from watchlist" : "Add to watchlist"}
      data-testid={`watch-${type}-btn`}
    >
      {saved ? <BookmarkCheck className="w-3.5 h-3.5" /> : <Bookmark className="w-3.5 h-3.5" />}
      {saved ? "Watching" : "Watch"}
    </button>
  );
};
